'use strict';

angular.module('atex.dam').controller('DamPublishingScheduleItemModalController', ['$scope', '$modal', '$timeout', '$rootScope', '$q', 'ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService', 'DamSchedulingService',
  function($scope, $modal, $timeout, $rootScope, $q, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService, DamSchedulingService) {
    $scope.panelTitle = $scope.model.isNew ? $translate.getTranslationTable().__ADD_NEW_PUBLISHING_SCHEDULE_ITEM__: $translate.getTranslationTable().__EDIT_PUBLISHING_SCHEDULE_ITEM__;
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.message = $scope.model.message;
    $scope.article = atex.Content();
    $scope.isValid = false;
    $scope.templateTypes = $scope.model.templateTypes;
    $scope.type = {"data" : null};
    $scope.showTimeslotPicker = false;
    $scope.timeSlotPresets = [{id : 0, label : $translate.getTranslationTable().__PUBLISHING_SCHEDULE_ASAP_OPTION__}, {id : 1, label : $translate.getTranslationTable().__PUBLISHING_SCHEDULE_PICK_TIME_OPTION__}];
    $scope.timeSlot = {
      "data":  $scope.timeSlotPresets[0],
      "value": undefined
    };

    $scope.article.data.aspects = {
      "contentData": {
        "data": {
          "_type": "atex.onecms.article",
          "timeState": {}
        }
      }
    };

    $scope.timeSlotPicker = {
      "id": "dam.timeSlot.picker",
      "dataBindings": [
        {
          "name" : "publicationDate",
          "widget": "pDateTimePicker",
          "config": {
            "dtConfig": {
              "format": "HH:mm"
            },
            "editable" : true,
            "useTimezone": false
          },
          "placeholder": $translate.getTranslationTable()._SELECT_TIME_,
          "domainObjects": {
            "data": "contentData/timeState/ontime"
          }
        }
      ]
    };

    DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      $scope.currentUserInfo = currentUserInfo;

        if ($scope.model.isNew === true) {
          $scope.model.planningItem = {
            "timeSlot" : {},
            "id" : DamSchedulingService.generateId()
          };
        } else {
          $scope.type = { "data" : $scope.model.planningItem.templateType };
          $scope.timeSlot = {};
          if (atex.onecms.ObjectUtils.getByPath($scope.model, "planningItem/timeSlot")) {
            atex.onecms.ObjectUtils.accessor($scope.timeSlot, "data").value = $scope.timeSlotPresets[1];
            $scope.showTimeslotPicker = true;
            var utcDate = resolveDate($scope.model.planningItem.timeSlot);
            $scope.article.data.aspects.contentData.data.timeState.ontime = utcDate.getTime();
          } else {
            atex.onecms.ObjectUtils.accessor($scope.timeSlot, "data").value = $scope.timeSlotPresets[0];
          }
        }
      $scope.hideSpinner();
      $scope.loaded = true;
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function submit(cleanData) {
      $scope.showSpinner = false;
      $scope.$parent.doOk(cleanData);
    }

    function resolveDate(timeSlot) {
      var hrs = moment(timeSlot, "HH:mm");
      var result = moment(hrs).utc().add(hrs.utcOffset(), 'm');
      var hour = result.hour();
      var minutes = result.minutes();

      var date = moment();
      var utcDate = date.tz("UTC", true).toDate();
      utcDate.setHours(hour);
      utcDate.setMinutes(minutes);
      utcDate.setSeconds(0);
      return utcDate;
    }

    $scope.doSave = function () {

      $scope.showSpinner = true;
      $scope.model.planningItem.templateType = $scope.type.data.id;
      if (atex.onecms.ObjectUtils.getByPath($scope.timeSlot, "data/id") === 1) {
        $scope.model.planningItem.timeSlot = $scope.article.data.aspects.contentData.data.timeState;
      } else {
        $scope.model.planningItem.timeSlot = undefined;
      }
      submit($scope.model.planningItem);
    };


    $scope.checkIfValid = function () {
      var name = $scope.model.planningItem.name;
      var type = $scope.type.data;
      var timeSlotData = atex.onecms.ObjectUtils.getByPath($scope.timeSlot , "data/id");
      var timeSlotOntime = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/timeState/ontime");
      var evalTimeSlot = timeSlotData === 0 ? true : (timeSlotOntime !== undefined && timeSlotOntime !== null);

      if (name && type && evalTimeSlot) {
        $scope.isValid = true;
      } else {
        $scope.isValid = false;
      }
    };

    $scope.isOkEnabled = function () {
      return !$scope.showSpinner && $scope.isValid && $scope.dirty;
    };

    $scope.onChange = function () {
      $scope.dirty = true;
      $scope.checkIfValid();
    };

    $scope.changeEndCallbackTimeSlot = function (data) {
      atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/timeState").value = data.aspects.contentData.data.timeState;

      if (atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/timeState/ontime")) {
        var date = new Date($scope.article.data.aspects.contentData.data.timeState.ontime);
        atex.onecms.ObjectUtils.accessor($scope.article, "data/aspects/contentData/data/timeState/ontime").value = date.getTime();
      }

      $scope.dirty = true;
      $scope.checkIfValid();
      if(!$scope.$$phase) {
        $scope.$digest();
      }
      return;
    };

    $scope.onTimeSlotSelectChange = function () {
      if ($scope.timeSlot.data !== undefined && $scope.timeSlot.data.id === 1) {
        $scope.showTimeslotPicker = true;
      } else {
        $scope.showTimeslotPicker = false;
      }

      $scope.dirty = true;
      $scope.checkIfValid();
    };

  }]);